import { ChatbotService } from "./chatbot.service";
import { ChatbotHistory, ChatbotPromptInfo } from "../../../shared/models/chatbot-history.model";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";

/***
 * This is the local backend implementation that uses the downloaded metadata to get data.
 */
export class ChatbotServiceLocal implements ChatbotService {
    public getContinuation = async (
        _site: string,
        _history: ChatbotHistory,
        _question: string,
        _org: string | null,
        _cfg: string | null,
        _request: MetadataRequest,
    ): Promise<ChatbotPromptInfo> => {
        return Promise.resolve({
            prompt: "",
            response: "",
            timestamp: 0,
            validity: "",
            references: [],
        });

    }
}
